import ReactSelect, { Props } from "react-select";
import { selectStyles } from "./Select.styles";
import './Select.scss';

interface SelectProps extends Props {}

export const Select = ({ ...props }: SelectProps) => {
  return <ReactSelect  classNamePrefix="general" {...props} styles={selectStyles}  />;
};
